import { ForemanDB } from "../../types/IndexedDB/ForemanDB"
import { Pallet, PalletItem } from "../../types/Material/Order"
import { showErrorToast } from "../CommonServices/alertServices"

export const mapPallets = async (db: ForemanDB, newPallets: Pallet[]) => {
    try {
        const allPalletItems: PalletItem[] = []
        
        for (const pallet of newPallets) {
            if (pallet.palletItems && pallet.palletItems.length > 0) {
                const palletItemsWithPalletId = pallet.palletItems.map(item => ({
                    ...item,
                    palletId: pallet.palletId
                }))
                allPalletItems.push(...palletItemsWithPalletId)
            }
        }
        
        const cleanPallets = newPallets.map(pallet => ({
            ...pallet,
            palletItems: []
        }))
        
        await db.transaction('rw', [db.pallets, db.palletItems], async () => {
            await db.pallets.clear()
            await db.palletItems.clear()
            db.setHooksEnabled(false)
            if (cleanPallets.length > 0) {
                await db.pallets.bulkAdd(cleanPallets)
            }
            
            if (allPalletItems.length > 0) {
                await db.palletItems.bulkAdd(allPalletItems)
            }
            db.setHooksEnabled(true)
        })
    } catch (error) {
        showErrorToast({
            message: 'Error mapping pallets',
        })
    }
}